import { create } from 'zustand'

import type { Entity } from '@/modules/shared/types/entity.type'
import type { Redespacho, Vendedor } from '../types/order-form-json.type'

export type TOrderFormComponentStoreState = {
  urlOrderPdf: string | undefined
  isOpenModalLoadExcel: boolean
  clients: Entity[] | undefined
	sellers: Entity[] | undefined
  isOpenModalSignatureOrder: boolean
  transports: Entity[] | undefined
  entityType: 'client' | 'transport' | 'seller'
  isOpenModalSchedule: boolean
  isOpenOrderFormModalEntity: boolean
  isOpenModalChangeCustomerData: boolean
  filterToCreatePaginationOfProduct: string
  openModalScheduleAfterSave: boolean
}

export type TOrderFormComponentStoreAction = {
  actions: {
    setUrlOrderPdf: (props: string | undefined) => void
    setIsOpenModalLoadExcel: (props: boolean) => void
    setEntityType: (type: 'client' | 'transport' | 'seller') => void
    setIsOpenModalSignatureOrder: (props: boolean) => void
    setCustomers: (payload: Entity[] | undefined) => void
    setTransports: (payload: Entity[] | undefined) => void
    setIsOpenModalSchedule: (props: boolean) => void
    setIsOpenOrderFormModalEntity: (props: boolean) => void
    setFilterToCreatePaginationOfProduct: (props: string) => void
    setIsOpenModalChangeCustomerData: (props: boolean) => void
    setOpenModalScheduleAfterSave: (props: boolean) => void
		setSellers: (payload: Entity[] | undefined) => void
  }
}

export const OrderFormComponentStore = create<
  TOrderFormComponentStoreAction & TOrderFormComponentStoreState
>((set) => ({
  clients: undefined,
  entityType: 'client',
  transports: undefined,
  urlOrderPdf: undefined,
  isOpenModalLoadExcel: false,
  isOpenModalSignatureOrder: false,
  isOpenOrderFormModalEntity: false,
  filterToCreatePaginationOfProduct: '',
  isOpenModalChangeCustomerData: false,
  isOpenModalSchedule: false,
  openModalScheduleAfterSave: false,
	sellers: undefined,
  actions: {
    setIsOpenModalChangeCustomerData: (props) =>
      set({ isOpenModalChangeCustomerData: props }),
    setEntityType: (type) => set({ entityType: type }),
    setCustomers: (payload) => set({ clients: payload }),
    setUrlOrderPdf: (props) => set({ urlOrderPdf: props }),
    setTransports: (payload) => set({ transports: payload }),
    setIsOpenModalLoadExcel: (props) => set({ isOpenModalLoadExcel: props }),
    setIsOpenModalSignatureOrder: (props) =>
      set({ isOpenModalSignatureOrder: props }),
    setIsOpenOrderFormModalEntity: (props) =>
      set({ isOpenOrderFormModalEntity: props }),
    setFilterToCreatePaginationOfProduct: (props) =>
      set({ filterToCreatePaginationOfProduct: props }),
    setIsOpenModalSchedule: (props) => set({ isOpenModalSchedule: props }),
    setOpenModalScheduleAfterSave: (props) =>
      set({ openModalScheduleAfterSave: props }),
		setSellers: (payload) => set({ sellers: payload }),
  },
}))

export const useOrderFormComponentStore = OrderFormComponentStore
export const useOrderFormComponentStoreActions =
  OrderFormComponentStore.getState().actions
